<template>
  <!-- import styles if needed -->
  <PageLoader class="mb-5 mt-5" v-if="isLoading"></PageLoader>
  <div v-if="is_loaded" v-show="!isLoading">
    <!-- import styles if needed -->

    <div v-if="is_loaded">
      <div id="current-user-wrapper">
        <snipp-current-user :campaign-id="campaignId" :user-status="user_status" @show-registration="showRegistration"
          @snipp-logout="handleSnippLogout" @show-confirmation="showConfirmation" @current-user="handleCurrentUser"
          :custom-css="customCssUrl" :language="$t('Language')"></snipp-current-user>
      </div>
      <div id="registration-wrapper" v-if="registration_enabled" ref="registrationSection">
        <snipp-registration app-source="CampaignWidget" refresh-reload="true" :campaign-id="campaignId"
          :show-confirmation="show_confirmation" :custom-css="customCssUrl" :is-logged-out="is_logged_out"
          @is-registered="handleIsRegistered" @snipp-widget-event="handleSnippWidgetEvent" :language="$t('Language')"></snipp-registration>
      </div>
      <div id="thanks-text" v-if="upload_enabled === 'upload_again'" ref="thanksSection" class="text-center py-5">
        <h1 class="mb-4 fw-bold">{{ $t('IPEwidget.ThanksTitle') }}</h1>
        <p v-html="$t('IPEwidget.ThanksDesc')" class="mb-0 mx-auto">
        </p>
      </div>
      <div id="upload-wrapper" v-if="upload_enabled" ref="uploadSection">
        <div id="upload-original" v-if="upload_enabled !== 'upload_again'">
          <div class="hide-dlr">
            <h2 class="text-center my-4">{{ $t('IPEwidget.UploadReceiptTitle') }}</h2>
          </div>
          <div class="show-dlr" style="display: none;">
            <h2 class="text-center my-4">{{ $t('IPEwidget.DLRTitle') }}</h2>
          </div>
          <div v-html="$t('IPEwidget.ImageUploadDesc1')" class="mt-4 mb-0 hide-dlr"></div>
          <div class="mt-4 mb-0 hide-dlr">
            <p><small v-html="$t('Home.ParticipatingProductLink')" @click="handleLinkClick"></small></p>
            <p><small v-html="$t('Home.HavingTroubleLink')" @click="handleLinkClick"></small></p>
          </div>
          <snipp-upload :campaign-id="campaignId" include-upload-button="true"
            @snipp-upload-result="handleSnippUploadResult" @snipp-widget-event="handleSnippWidgetEvent"
            :custom-css="customCssUrl" :language="$t('Language')"></snipp-upload>

        </div>
        <div id="upload-again" v-if="upload_enabled === 'upload_again'">
          <snipp-upload :campaign-id="campaignId" include-upload-again-button="true"
            @snipp-upload-result="handleSnippUploadResult" :custom-css="customCssUrl"
            :language="$t('Language')"></snipp-upload>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageLoader from '../../../components/UI/PageLoader.vue';

const SIGN_UP_FIELD_ALIASES = {
  firstname: 'first_name',
  lastname: 'last_name',
  first_name: 'first_name',
  last_name: 'last_name',
  zipcode: 'zip',
  postalcode: 'zip',
  dob: 'birthdate',
  birthdate: 'birthdate',
  street: 'address',
  streettwo: 'address2',
};

export default {
  components: { PageLoader },
  props: ['campaignId'],
  emits: [],
  data() {
    return {
      ts: Date.now(),
      isLoading: true,
      is_loaded: false,
      is_logged_out: undefined,
      upload_enabled: undefined,
      registration_enabled: false,
      show_confirmation: undefined,
      user_status: undefined,
      uploadLimitReached: false,
      showDlr: false,
      customCssUrl: '/assets/css/custom_overrides.css',
      gateDob: sessionStorage.getItem('DateOfBirth') || undefined,
      gateState: sessionStorage.getItem('State') || undefined,
    };
  },
  methods: {
    findInShadowTree(root, id) {
      if (!root) return null;
      const direct = root.getElementById ? root.getElementById(id) : null;
      if (direct) return direct;

      const all = root.querySelectorAll ? root.querySelectorAll('*') : [];
      for (const el of all) {
        if (el.shadowRoot) {
          const found = this.findInShadowTree(el.shadowRoot, id);
          if (found) return found;
        }
      }
      return null;
    },
    async prefillIpeGateData() {
      const needsState = this.gateState;
      const needsDob = this.gateDob;
      if (!needsState && !needsDob) return;

      let stateDone = !needsState;
      let dobDone = !needsDob;

      for (let i = 0; i < 40; i++) {
        const root = document.querySelector('snipp-registration')?.shadowRoot;
        if (root) {
          if (needsState && !stateDone) {
            const select = this.findInShadowTree(root, 'dropdown_state');
            if (select) {
              select.value = this.gateState;
              if (select.value !== this.gateState) {
                const match = Array.from(select.options || []).find(
                  (opt) =>
                    opt.value.toLowerCase() === this.gateState.toLowerCase() ||
                    opt.textContent.trim().toLowerCase() === this.gateState.toLowerCase()
                );
                if (match) select.value = match.value;
              }
              select.dispatchEvent(new Event('input', { bubbles: true }));
              select.dispatchEvent(new Event('change', { bubbles: true }));
              // Lock the field after the widget has captured the value
              select.disabled = true;
              select.setAttribute('aria-disabled', 'true');
              stateDone = true;
            }
          }
          if (needsDob && !dobDone) {
            const dob = this.findInShadowTree(root, 'input_birthdate');
            if (dob) {
              dob.value = this.gateDob;
              dob.dispatchEvent(new Event('input', { bubbles: true }));
              dob.dispatchEvent(new Event('change', { bubbles: true }));
              dob.readOnly = true;
              dob.setAttribute('aria-readonly', 'true');
              dobDone = true;
            }
          }
          if (stateDone && dobDone) return;
        }
        await new Promise((r) => setTimeout(r, 150));
      }
    },
    showRegistration(confirmation) {
      if (this.upload_enabled) this.upload_enabled = undefined;
      if (confirmation) {
        this.show_confirmation = true;
      } else {
        this.show_confirmation = undefined;
      }
      this.registration_enabled = true;
      this.$nextTick(() => {
        this.$refs.registrationSection?.scrollIntoView({ behavior: 'smooth' });
      });
    },
    showConfirmation() {
      this.showRegistration(true);
    },
    handleSnippLogout() {
      this.upload_enabled = undefined;
      this.is_logged_out = true;
      this.showRegistration();
    },
    handleIsRegistered() {

      this.user_status = Date.now();
      this.upload_enabled = 'upload';
      this.registration_enabled = false;
      this.$nextTick(() => {
        this.$refs.uploadSection?.scrollIntoView({ behavior: 'smooth' });
      });
    },
    handleSnippUploadResult() {
      this.upload_enabled = 'upload_again';
      this.$nextTick(() => {
        this.$refs.thanksSection?.scrollIntoView({ behavior: 'smooth' });
      });
    },
    handleEnterAgain() {
      this.upload_enabled = 'upload';
      this.$nextTick(() => {
        this.$refs.uploadSection?.scrollIntoView({ behavior: 'smooth' });
      });
    },
    handleSnippWidgetEvent(e) {
      if (e && e.detail && e.detail.length) {
        let message = e.detail[0];

        if (message.is_registered && message.user_info) {
          const raw = message.user_info;
          const user = { login_status: 'success', user_id: '' };
          
          Object.entries(raw).forEach(([key, value]) => {
            if (key === 'customFields') return;
            const mapped = SIGN_UP_FIELD_ALIASES[key] || key;
            user[mapped] = value;
          });

          if (sessionStorage.getItem('DateOfBirth') && !user.birthdate) user.birthdate = sessionStorage.getItem('DateOfBirth');
          if (sessionStorage.getItem('State') && !user.state) user.state = sessionStorage.getItem('State');
          if (!user.country) user.country = 'US';

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'sign_up',
            method: 'email',
            login_status: 'success',
            user,
          });
          return;
        }

        const elements2 = document.querySelectorAll('.show-dlr');
        if (message.upload_limit_reached) {
          this.uploadLimitReached = true;
          this.showDlr = true;
          const elements = document.querySelectorAll('.hide-dlr');
          elements.forEach(el => {
            el.style.display = 'none';
          });
          elements2.forEach(el => {
            el.style.display = 'block';
          });
        } else {
          elements2.forEach(el => {
            el.style.display = 'none';
          });
        }
      }
    },
    handleCurrentUser() {
      this.registration_enabled = false;
      this.upload_enabled = 'upload';
    },
    handleLinkClick(event) {
      const target = event.target.closest('a');
      if (target) {
        const href = target.getAttribute('href');
        if (href && href.startsWith('/')) {
          event.preventDefault();
          const routeName = href.substring(1);
          if (routeName) {
            this.$router.push({ name: routeName }).catch(() => {
              this.$router.push(href);
            });
          }
        }
      }
    },
  },
  mounted() {
    this.is_loaded = true;
    setTimeout(() => (this.isLoading = false), 1500);
  },
  watch: {
    registration_enabled(val) {
      if (val) {
        this.$nextTick(() => {
          this.prefillIpeGateData();
        });
      }
    }
  },
};
</script>

<style scoped>
.wrapper {
  margin-top: 57px;
}
.color-red {
  color: #bf233a;
}
#current-user-wrapper,
#upload-wrapper {
  max-width: 70%;
  margin: 0 auto;
}
@media screen and (max-width: 575px) {
  #current-user-wrapper,
  #upload-wrapper {
    max-width: 100%;
    margin: 0 auto;
  }
}
</style>
